import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow ? (
          <span className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
            <span className="h-3 w-[3px] rounded-full bg-primary-500" />
            {eyebrow}
          </span>
        ) : null}
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {description ? (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{description}</p>
        ) : null}
      </div>
      {actionLabel && actionTo ? (
        <Link
          to={actionTo}
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
        >
          {actionLabel}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-s-line text-base" />
          </span>
        </Link>
      ) : null}
    </div>
  );
}